import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { setDeleteLoading } from "../../menu/menuSlice";
import {
  errorAlertHandle,
  successAlertHandle,
} from "../../../../utils/utilFunctions";

export const getRoles = createAsyncThunk(
  "role/getRoles",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({ ...filters });
    const res = await axios.post(
      `/api/rbac/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const getRole = createAsyncThunk(
  "role/getRole",
  async ({ start, limit }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({});
    const res = await axios.post(
      `/api/rbac/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const addRole = createAsyncThunk(
  "role/addRole",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify(data);
      const res = await axios.post("/api/rbac", body, config);
      successAlertHandle("Role added successfully!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const updateRole = createAsyncThunk(
  "role/updateRole",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify(data);
      const res = await axios.put("/api/rbac", body, config);
      successAlertHandle("Role updated successfully!", dispatch);
      return res.data;
    } catch (err) {
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const deleteRole = createAsyncThunk(
  "role/deleteRole",
  async (id, { dispatch, rejectWithValue }) => {
    dispatch(setDeleteLoading(true));
    try {
      const res = await axios.delete(`/api/rbac?id=${id}`);
      successAlertHandle("Role deleted successfully!", dispatch);
      dispatch(setDeleteLoading(false));
      return res.data;
    } catch (err) {
      dispatch(setDeleteLoading(false));
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const getMenus = createAsyncThunk("role/getMenus", async () => {
  const res = await axios.get("/api/rbac/menu");
  return res.data;
});

export const getActionByMenus = createAsyncThunk(
  "role/getActionByMenus",
  async (data) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify(data);
    const res = await axios.post("/api/rbac/action", body, config);
    return res.data;
  }
);
